export function preloader() {
    let preloader = $(".preloader");
    let animObj = lottie.loadAnimation({
        container: preloader[0], // the dom element that will contain the animation
        renderer: "svg",
        loop: false,
        autoplay: true,
        path: preloader.data("animation-path")
    });

    animObj.addEventListener("config_ready", function () {
        $(".wrap-preloader").addClass("init");
    });

    animObj.addEventListener("complete", function () {
        $("body").trigger("preloaderComplete");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/preloader.js